import {
    GET_COMMON_KNOWLEDGE_BY_ID,
    GET_COMMON_KNOWLEDGE_FAIL,
    GET_COMMON_KNOWLEDGE_REQUEST,
    GET_COMMON_KNOWLEDGE_SUCCESS
} from "../constant";



const initialState = {
    commonKnowledges: [],
    knowledge: {},
    knowledgeDataLoading: false
};



const commonKnowledgeReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_COMMON_KNOWLEDGE_REQUEST:
            return {
                ...state,
                commonKnowledges: [],
                knowledge: {},
                knowledgeDataLoading: true
            };
        case GET_COMMON_KNOWLEDGE_SUCCESS:
            return {
                ...state,
                commonKnowledges: action.payload,
                knowledgeDataLoading: false
            };
        case GET_COMMON_KNOWLEDGE_FAIL:
            return {
                ...state,
                commonKnowledges: [],
                knowledge: {},
                knowledgeDataLoading: false
            };

        case GET_COMMON_KNOWLEDGE_BY_ID:
            return {
                ...state,
                knowledge: action.payload
            }
        default:
            return state;
    }
};

export { commonKnowledgeReducer };